import React from "react";
import styled from 'styled-components'
import { Row, Col } from "antd";

export default class Contato extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: ""
    };
  }

  render() {
    const { status } = this.state;
    return (
        <>
            <Row justify={'center'}>
                <Col>
                    <H2>Contato</H2>
                </Col>
            </Row>
            <Row justify={'center'}>
                <Col xs={20} sm={20} md={12} lg={8} xl={8}>
                    <Form
                        onSubmit={this.submitForm}
                        action="https://formspree.io/mjvaplep"
                        method="POST"
                    >
                        
                        <Input type="email" placeholder='Email' name="email" />
                        
                        <Text type="text" placeholder='Mensagem' name="message" rows='4' />

                        {status === "SUCCESS" ? <p>Thanks!</p> : <Button>Submit</Button>}
                        {status === "ERROR" && <p>Ooops! There was an error.</p>}
                    </Form>
                </Col>
            </Row>
        </>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}

const Input = styled.input`
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0, .5);
    padding: 5px 15px;
`

const Text = styled.textarea`
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0, .5);
    padding: 5px 15px;
`

const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: auto;
`

const Button = styled.button`
    border-radius: 5px;
    border: 1px solid #0E3;
    padding: 5px 15px;
    background: #0E3;
    color: rgba(0,0,0, .75)!important;
    font-weight: bold;
    text-transform: uppercase;
`

const H2 = styled.h2`
    font-size: 30px;
`